/**
 * Transactions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TransactionsSummary200Response { 
    Tested_Hit: number;
    Tested_No_Hit: number;
    Not_Tested_Non_Client_CCs_only: number;
    Not_Tested_No_CCs: number;
}


